import { render, staticRenderFns } from "./DetailEmployeeAllowance.vue?vue&type=template&id=5d48b710"
import script from "./DetailEmployeeAllowance.vue?vue&type=script&lang=js"
export * from "./DetailEmployeeAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports